module.exports = __webpack_public_path__ + "assets/img/right.d2f3afa6.svg";